export default __webpack_public_path__ + "static/media/PokedexMockup.c489e161.png";